module.exports = __webpack_public_path__ + "static/media/calm_neutral.477e932b.svg";